<template>
  <div :class="className" @click="handleLinkClicks" v-html="text"></div>
  <ExternalLinkModal
    :open="externalLinkModalOpen"
    :redirect-url="externalLinkUrl"
    @close="externalLinkModalOpen = false"
  ></ExternalLinkModal>
</template>

<script>
import ExternalLinkModal from "../layout/ExternalLinkModal.vue";

export default {
  name: "ArticleText",
  components: { ExternalLinkModal },
  props: {
    text: null,
    className: null,
  },
  data: function () {
    return {
      externalLinkUrl: null,
      externalLinkModalOpen: false,
    };
  },
  methods: {
    handleLinkClicks(event) {
      event.preventDefault();
      if (event.target.tagName === "A") {
        this.externalLinkUrl = event.target.href;
        this.externalLinkModalOpen = true;
      }
    },
  },
};
</script>
